"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.FolderOpenedIcon = function () { return (react_1.default.createElement("svg", { viewBox: "0 0 16 16" },
    react_1.default.createElement("polygon", { fill: "#e0aa38", points: "8.913 1 5.713 4 0 4 0 15 14 15 14 4 14 1 8.913 1" }),
    react_1.default.createElement("polygon", { fill: "#fff", points: "9.421 2 6.222 5 1 5 1 14 13 14 13 5 13 2 9.421 2" }),
    react_1.default.createElement("polygon", { fill: "#e0aa38", points: "3 6 0 15 14 15 16 6 3 6" }),
    react_1.default.createElement("polygon", { fill: "#e0aa38", points: "13.198 14 1.387 14 3.721 7 14.753 7 13.198 14" }),
    react_1.default.createElement("polygon", { fill: "#f2c973", points: "3.721 7 1.387 14 13.198 14 14.753 7 3.721 7" }))); };
//# sourceMappingURL=FolderOpenedIcon.js.map